import { updatesData } from '@/mocks/homeData';

const categoryStyles: Record<string, string> = {
  '突发事件': 'bg-primary-100 text-primary-700',
  '独家爆料': 'bg-accent-100 text-accent-700',
  '恋情曝光': 'bg-accent-100 text-accent-700',
  '人设崩塌': 'bg-secondary-100 text-secondary-700',
  '行业黑幕': 'bg-secondary-100 text-secondary-700',
  '商业动态': 'bg-secondary-100 text-secondary-700',
  '明星八卦': 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-[860px]">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-flex items-center gap-1 px-3 py-1 text-xs font-semibold text-primary-600 bg-primary-100 rounded-full mb-3">
            <i className="ri-timer-flash-line text-sm"></i>
            LIVE
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900">实时快讯</h2>
          <p className="mt-2 text-sm text-foreground-600">最新最热的爆料动态实时滚动更新</p>
        </div>

        <div className="relative pl-8 md:pl-10">
          <div className="absolute left-3 md:left-[14px] top-2 bottom-2 w-px bg-background-300"></div>

          <div className="space-y-6">
            {updatesData.map((item) => (
              <a
                key={item.id}
                href="#cards"
                className="relative block group cursor-pointer"
              >
                <div className="absolute left-[-22px] md:left-[-24px] top-1.5 w-3 h-3 rounded-full border-2 border-primary-500 bg-background-50 group-hover:bg-primary-500 transition-colors"></div>
                <div className="bg-background-50 rounded-lg border border-background-200/60 p-4 md:p-5 hover:border-primary-200 transition-colors">
                  <div className="flex flex-wrap items-center gap-2 md:gap-3 mb-1.5">
                    <span className="text-[11px] text-foreground-500 whitespace-nowrap">{item.time}</span>
                    <span className={`px-1.5 py-0.5 text-[10px] font-semibold rounded ${categoryStyles[item.category] || 'bg-background-200 text-foreground-600'}`}>
                      {item.category}
                    </span>
                  </div>
                  <p className="text-sm md:text-base font-semibold text-foreground-800 leading-snug group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}